import ConnectedAddPayrollInformationForm from './AddPayrollInformationForm';

export default ConnectedAddPayrollInformationForm;
